// MS50 #3003 — "resume-reveal" Stimulus controller.
//
// CSP-safe replacement for the nonce-less inline <script> that toggled the
// "upload new resume" field on the PUBLIC application form. The enforcing nonce
// CSP (script-src :self + nonce, no unsafe_inline — #1222) blocks nonce-less
// inline scripts, so switching "use existing resume" vs "upload new resume"
// never revealed/hid the upload field. connect() sets the initial state
// (mirroring the server-rendered display) and each radio change re-evaluates it.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["upload", "newRadio"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasUploadTarget) return
    const showNew = this.hasNewRadioTarget && this.newRadioTarget.checked
    // #new_resume_upload renders with .d-none when a resume exists; reveal it
    // only when "upload new" is selected.
    this.uploadTarget.classList.toggle("d-none", !showNew)
  }
}
